/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Toggle/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'
import TysiaToggleText from 'DesignSystem/TysiaToggle/TysiaToggleText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Toggle({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/Accounts/Content/ProviderAccount/Settings/Content/Toggle"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let authAccessTokenDataIsSupportValueData = fromData.useDataValue({ viewPath,
context: 'auth',
path: 'access_token_data.is_support',
})
let providerAccountFeeModeValueData = fromData.useDataValue({ viewPath,
context: 'provider_account',
path: 'fee_mode',
})
let constantData = 'STANDARD'
let aggregateData = fromAggregate.equals(providerAccountFeeModeValueData, constantData)
let onClick = fromHelpers.useOnChangeStandard({
  children,
  viewPath
  
})
let authAccessTokenDataIsSupportValueData1 = fromData.useDataValue({ viewPath,
context: 'auth',
path: 'access_token_data.is_support',
})
let providerAccountFeeModeValueData1 = fromData.useDataValue({ viewPath,
context: 'provider_account',
path: 'fee_mode',
})
let constantData1 = 'PLATFORM_FEE'
let aggregateData1 = fromAggregate.equals(providerAccountFeeModeValueData1, constantData1)
let onClick1 = fromHelpers.useOnChangePlatformFee({
  children,
  viewPath
  
})
let authAccessTokenDataIsSupportValueData2 = fromData.useDataValue({ viewPath,
context: 'auth',
path: 'access_token_data.is_support',
})
let providerAccountFeeModeValueData2 = fromData.useDataValue({ viewPath,
context: 'provider_account',
path: 'fee_mode',
})
let constantData2 = 'SURCHARGE'
let aggregateData2 = fromAggregate.equals(providerAccountFeeModeValueData2, constantData2)
let onClick2 = fromHelpers.useOnChangeSurcharge({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Toggle.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z26RBpx': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaToggleText
  viewPath={`${viewPath}/TysiaToggleText`}
 text="Choose how to handle processing fees:"
/>
<Radial
  viewPath={`${viewPath}/Radial`}
 onClick={onClick}
 data="auth.access_token_data.is_support"
 disabled={!authAccessTokenDataIsSupportValueData}
 data="provider_account.fee_mode"
 data="'STANDARD'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 text="Standard"
/>
<Radial
  viewPath={`${viewPath}/Radial`}
 onClick={onClick1}
 data="auth.access_token_data.is_support"
 disabled={!authAccessTokenDataIsSupportValueData1}
 data="provider_account.fee_mode"
 data="'PLATFORM_FEE'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData1}
 text="Platform fee"
/>
<Radial
  viewPath={`${viewPath}/Radial`}
 onClick={onClick2}
 data="auth.access_token_data.is_support"
 disabled={!authAccessTokenDataIsSupportValueData2}
 data="provider_account.fee_mode"
 data="'SURCHARGE'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData2}
 text="Surcharge"
/>
</div>
{children}
</React.Fragment>)
}